module.exports = __webpack_public_path__ + "img/noComp.c1b1cc7c.png";